/*import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Import the router instance
import './assets/global.css'
import { i18n } from './i18n'

//const app = createApp(App)

app.use(router) // Install the plugin
app.mount('#app')
//app.use(i18n) */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/global.css'
import { i18n } from './i18n'
import favicon from './assets/favicon.png'

const faviconElement = document.querySelector("link[rel='icon']")
if (faviconElement) {
  faviconElement.href = favicon
}

createApp(App)
  .use(i18n)
  .use(router)
  .mount('#app')
